"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventWrapper = eventWrapper;
var _dom = require("@testing-library/dom");
function eventWrapper(cb) {
  var result;
  (0, _dom.getConfig)().eventWrapper(function () {
    result = cb();
  });
  return result;
}